module.exports = __webpack_public_path__ + "static/media/Polygon-darkBlue.5b0c7859.svg";